import {
	animate,
	keyframes,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';

export const enterAnimation = trigger('enterAnimation', [
	transition(':enter', [
		style({ opacity: 0, 'margin-top': '100%' }),
		animate('100ms ease-in-out', style({ opacity: 1, 'margin-top': '50%' })),
		animate('300ms ease-in-out', style({ opacity: 1, 'margin-top': 0 })),
	]),
	transition(':leave', [
		style({ top: '50%', opacity: 1 }),
		animate('200ms', style({ top: '0', opacity: 0 })),
	]),
]);

export const loadingAnimation = trigger('loadingAnimation', [
	transition(':enter', [
		style({ bottom: '60px', opacity: 0 }),
		animate('0ms', style({ bottom: '80px', opacity: 1 })),
		animate('50ms', style({ bottom: '60px', opacity: 1 })),
	]),
	transition(':leave', [
		style({ bottom: '60px', opacity: 1 }),
		animate('50ms', style({ bottom: '80px', opacity: 1 })),
		animate('100ms', style({ bottom: '0', opacity: 0 })),
	]),
]);

export const changeAnimation = trigger('changeAnimation', [
	state('*', style({ transform: 'translate(0,0)' })),
	transition(
		'* <=> *',
		animate(
			'500ms ease-in',
			keyframes([
				style({ opacity: 0.6, transform: 'translate(0, 8px)', offset: 0 }),
				style({ opacity: 0.8, transform: 'translate(0, 0)', offset: 0.5 }),
				style({ opacity: 1.0, transform: 'translate(0, 0)', offset: 1.0 }),
			])
		)
	),
]);

export const tableAnimation = trigger('tableAnimation', [
	transition(':enter', [
		style({ opacity: 0, 'margin-top': '-100%' }),
		animate('100ms', style({ opacity: 1, 'margin-top': '-50%' })),
		animate('300ms', style({ opacity: 1, 'margin-top': 0 })),
	]),
	transition(':leave', [
		style({ top: '50%', opacity: 1 }),
		animate('200ms', style({ top: '0', opacity: 0 })),
	]),
]);

export const slideDownAnimation = trigger('slideDownAnimation', [
	transition(':enter', [
		style({ height: 0, overflow: 'hidden', opacity: 0 }),
		animate(
			'400ms ease-in-out',
			style({ height: '100%', overflow: 'unset', opacity: '100%' })
		),
	]),
]);

export const slideLeftAnimation = trigger('slideLeftAnimation', [
	transition(':enter', [
		style({ width: 0, overflow: 'hidden', opacity: 0 }),
		animate(
			'400ms ease-in-out',
			style({ width: '100%', overflow: 'unset', opacity: '100%' })
		),
	]),

	transition(':leave', [
		style({ width: '100%', overflow: 'unset', opacity: '100%' }),
		animate(
			'400ms ease-in-out',
			style({ width: 0, overflow: 'hidden', opacity: 0 })
		),
	]),
]);

export const slideNotification = trigger('slideNotification', [
	state('true', style({ top: '16px', opacity: 100 })),
	state('false', style({ top: '-50%', opacity: 0 })),
	transition('true => false', animate('600ms ease-in')),
	transition('false => true', animate('100ms ease-in')),
]);

export const slideLeftSidebar = trigger('slideLeftSidebar', [
	transition(':enter', [
		style({ right: '-50%' }),
		animate('400ms ease-in', style({ right: '0' })),
	]),

	transition(':leave', [
		style({ right: '0' }),
		animate('400ms ease-in', style({ right: '-50%' })),
	]),
]);

export const fadeInOut = trigger('fadeInOut', [
	transition(':enter', [
		style({ opacity: '0' }),
		animate('400ms ease-in', style({ opacity: '100' })),
	]),

	transition(':leave', [
		style({ opacity: '100' }),
		animate('400ms ease-in', style({ opacity: '0' })),
	]),
]);
